<template>
  <transition name="slide-fade">
    <div v-if="component404">
      <h5>Resource not found</h5>
    </div>
    <div
      v-if="!componentLoading"
      id="media-view"
      class="media shadow rounded bg-white mx-1 px-5 p-4"
    >
      <div class="row">
        <div class="col-12 col-md-6 d-flex flex-column justify-content-around">
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex flex-row align-items-center mb-4">
              <i class="material-icons material-icons-title mr-2">perm_media</i>
              <h2 class="mt-2">{{media.name}}</h2>
            </div>
          </div>

          <div class="align-self-start d-flex flex-column">
            <div class="w-100 flex-start align-self-start">
              <div class="d-flex flex-column media-stats">
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">perm_media</i>
                  <em>Media Type:</em>
                  <span class="element-label">
                    <em v-if="media.is_video">Video</em>
                    <em v-else>Image</em>
                  </span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">save</i>
                  <em>Filesize:</em>
                  <span class="element-label">
                    <em>{{ humanFileSize }}</em>
                  </span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">save_alt</i>
                  <em>Downloads:</em>
                  <span class="element-label">
                    <em>{{ media.num_downloads }}</em>
                  </span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">person</i>
                  <em>Contributed By:</em>
                  <router-link
                    :to="{ name: 'view-user', params: { id: media.contriubted_by } }"
                  >{{ media.first_name }} {{ media.last_name }}</router-link>
                </div>
              </div>
            </div>

            <div class="my-2">{{ media.description }}</div>
            <ul v-if="media.tags" class="media-tags d-flex flex-wrap px-0 my-3 w-100">
              <li
                v-bind:key="tag.id"
                v-for="tag in tags"
                v-bind:class="{ selected: tag.isCurrentlySelected }"
              >{{ tag.title }}</li>
            </ul>
          </div>
          <a class="mr-2" @click.prevent="downloadMedia">
            <button class="btn btn-primary mb-4">
              <i class="material-icons">save_alt</i>
            </button>
          </a>
        </div>
        <div class="col-12 col-md-6 justify-content-center">
          <div class="image-container w-100 py-4 d-flex justify-content-center">
            <img v-bind:src="media.signed_thumb_url" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="componentLoading" class="please-wait">
      <PleaseWait></PleaseWait>
    </div>
  </transition>
</template>

<script>
import MediaService from "../services/media.service";
import { store } from "../store/store";
import PleaseWait from "../components/PleaseWait";

export default {
  name: "MediaView",
  computed: {
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    },
    appLoading() {
      return this.$store.getters.getAppLoading;
    },
    humanFileSize() {
      var i = Math.floor(Math.log(this.media.file_size) / Math.log(1024));
      return (
        (this.media.file_size / Math.pow(1024, i)).toFixed(2) * 1 +
        " " +
        ["B", "kB", "MB", "GB", "TB"][i]
      );
    }
  },
  data: function() {
    return {
      componentLoading: true,
      component404: false,
      media: {},
      isFavouritedByUser: false,
      fileSize: 0
    };
  },

  watch: {
    "$route.params.uuidId": function() {
      this.media = {};
      this.getMedia(this.$route.params.uuidId);
    }
  },
  components: {
    PleaseWait
  },

  methods: {
    downloadMedia() {
      MediaService.downloadMedia(this.$route.params.uuidId).then(data => {
        if (this.isOnNative) {
          let url = data.url;
          window.webkit.messageHandlers.mediaImport.postMessage({
            url: data.url,
            fileName: data.fileName
          });
        } else {
          window.location = data.url;
        }
      });
    },
    getMedia(uuidId) {
      this.componentLoading = true;
      MediaService.mediaItem(uuidId)
        .then(data => {
          this.media = data;
          this.tags = data.tags;
          this.isFavouritedByUser = data.is_favourited_by_current_user;
          this.componentLoading = false;
          this.setRouteParams(this.media.name);
        })
        .catch(error => {
          if (error.message.includes("404")) {
            this.component404 = true;
          }
        });
    },
    setRouteParams(param) {
      this.$route.meta.breadcrumb.label = param;
      this.$router.replace({ query: { temp: Date.now() } });
      this.$router.replace({ query: { temp: undefined } });
    }
  },
  beforeMount() {
    this.media = {};
    this.getMedia(this.$route.params.uuidId);
  }
};
</script>


<style>
.media-image-popup {
  width: 90%;
  height: 90%;
}
</style>

<style scoped>
.media {
  flex-direction: column;
}

.image-container {
  max-width: 100%;
  height: auto;
}

.image-container img {
  width: 100%;
  height: auto;
}

.media-elements {
  padding: 0;
  margin: 0;
}
.media-elements li {
  display: inline-block;
  height: 50px;
}
.media-tags li {
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.media-elements li i {
  margin-right: 5px;
}

li .tiny-span {
  font-size: 12px;
  color: #CB2E37;
}

.media-tags li {
  margin: 2px;
  display: inline-block;
  color: #fff;
  background-color: #6c757d;

  border-radius: 7px;
  padding: 4px;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.media-stats em {
  color: #6c757d;
  margin-right: 10px;
  font-size: 14px;
}

.media-stats i {
  margin-right: 5px;
}
.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}

.please-wait {
  height: 60vh;
}
</style>
